module.exports = __webpack_public_path__ + "img/timeline_mainevent-5.c178a027.jpg";